var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "avatar_svg__a",
    cx: 35,
    cy: 35,
    r: 35
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avatar_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avatar_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#CCC",
    xlinkHref: "#avatar_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#avatar_svg__b)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.998 40c10.916 0 18.5 6.883 21.002 13.552C50.514 58.79 43.111 62 34.966 62 26.854 62 19.478 58.816 14 53.619 16.473 46.929 24.066 40 34.998 40zM35 15c5.885 0 11 4.617 11 10.849C46 32.156 40.885 37 35 37c-5.913 0-11-4.844-11-11.1C24 19.717 29.115 15 35 15z"
  })))));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8Y2lyY2xlIGlkPSJhIiBjeD0iMzUiIGN5PSIzNSIgcj0iMzUiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iI0NDQyIgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8ZyBtYXNrPSJ1cmwoI2IpIiBmaWxsPSIjRkZGIj4KICAgICAgICAgICAgPHBhdGggZD0iTTM0Ljk5OCA0MGMxMC45MTYgMCAxOC41IDYuODgzIDIxLjAwMiAxMy41NTJDNTAuNTE0IDU4Ljc5IDQzLjExMSA2MiAzNC45NjYgNjIgMjYuODU0IDYyIDE5LjQ3OCA1OC44MTYgMTQgNTMuNjE5IDE2LjQ3MyA0Ni45MjkgMjQuMDY2IDQwIDM0Ljk5OCA0MHpNMzUgMTVjNS44ODUgMCAxMSA0LjYxNyAxMSAxMC44NDlDNDYgMzIuMTU2IDQwLjg4NSAzNyAzNSAzN2MtNS45MTMgMC0xMS00Ljg0NC0xMS0xMS4xQzI0IDE5LjcxNyAyOS4xMTUgMTUgMzUgMTV6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgAvatar as ReactComponent };